<tt-page>
    <tt-card class="flex-1 col-xs-12 col-md-6 sp-0" ttClass="flex-column height-full">
        <tt-doc-article-edit [params]="params" (submit)="state.back($event.back)"></tt-doc-article-edit>
    </tt-card>
</tt-page>
